import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {AuthService} from "../../../core/service/auth.service";
import {EndUserSignatureOverviewDto, SignatureDto} from "../../../cross/user-signatures/type/user-signatures.types";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {UserDocumentApiService} from "../../../cross/user/api/user-document-api.service";
import {UserDocumentDto} from "../../../cross/user/types/user.types";


@Component({
  selector: 'ds-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent extends CoreComponent {

    userDocuments?: UserDocumentDto[];
    showDocumentVisible: boolean = false;
    showDocumentId: number | undefined

  constructor(protected router: Router,
              protected registrationApiService: RegistrationApiService,
              protected userDocumentApiService: UserDocumentApiService,
              protected messageService: AppMessageService,
              protected formBuilder: FormBuilder,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.getDocuments();
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {

  }

  handleDownload(documentId: number) {

    this.showDocumentId = documentId;
    this.showDocumentVisible = true;
    // this.userDocumentApiService.getDocumentBinary(documentId).subscribe(value => {
    //
    // });

  }

  getDocuments() {

    this.userDocumentApiService.list().subscribe(value => {

      this.userDocuments = value;
      this.initialized = true;
    });
  }

  handleWindowOpened(event: boolean) {
    this.showDocumentVisible = false;
  }

}
